import { isTripProductDay, tripClockParts } from './tripTime'

export const DAILY_PHOTO_OPEN_MINUTE = 2 * 60
export const DAILY_PHOTO_REVEAL_MINUTE = 22 * 60

export type DailyPhotoPhase = 'outside_trip' | 'locked' | 'open' | 'revealed'
export type DailyPhotoMode = 'individual' | 'multiple_candidates' | 'collective'

function minuteOfDay(instant: Date): { date: string; minute: number } {
  const parts = tripClockParts(instant)
  return { date: parts.date, minute: parts.hour * 60 + parts.minute }
}

export function dailyPhotoPhase(productDay: string, now = new Date()): DailyPhotoPhase {
  if (!isTripProductDay(productDay)) return 'outside_trip'
  const current = minuteOfDay(now)
  if (current.date < productDay) return 'locked'
  if (current.date > productDay) return 'revealed'
  if (current.minute < DAILY_PHOTO_OPEN_MINUTE) return 'locked'
  return current.minute < DAILY_PHOTO_REVEAL_MINUTE ? 'open' : 'revealed'
}

export function isDailyCandidateAdmissible(
  createdAtDevice: string,
  productDay: string,
  receivedAtServer?: string,
): boolean {
  void receivedAtServer
  if (!isTripProductDay(productDay)) return false
  const created = new Date(createdAtDevice)
  if (Number.isNaN(created.getTime())) return false
  const local = minuteOfDay(created)
  return (
    local.date === productDay &&
    local.minute >= DAILY_PHOTO_OPEN_MINUTE &&
    local.minute < DAILY_PHOTO_REVEAL_MINUTE
  )
}

export function validateDailyPhotoMode(value: string): DailyPhotoMode {
  if (value === 'individual' || value === 'multiple_candidates' || value === 'collective') return value
  throw new Error('Mode de photo du jour invalide : aucun classement global n’est prévu.')
}
